import { useEffect, useState } from "react";
import { ApiBaseUrl } from "../../Config";
import axios from "axios";
import Swal from "sweetalert2";

export default function ChartGridView({ warehouse_name, type,ids }) {
  const [loading, setLoading] = useState(false);
  const [Data, setData] = useState([]);

  var index = 0;
  const GetData = async () => {
    setLoading(true);
    let url = `${ApiBaseUrl}/warehouse/map/dashboard/view?warehouse_name=${warehouse_name}&type=${type}&ids=${ids}`;
    try {
      const response = await axios.get(url);
      if (response?.data?.data) {
        setData(response.data.data);
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error Fetching Data: ${error.message}`,
        timer: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, [warehouse_name, type,ids]);

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="container">
        <div className="card mt-5">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-striped table-sm text-center">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>Location Code</th>
                  </tr>
                </thead>
                <tbody>
                  {Data.length > 0 ? (
                    Data.map((item) => {
                      if (item.new_location_code != "CAMERA NOT INSTALL") {
                        index++;
                        return (
                          <tr key={index}>
                            <td>{index}</td>
                            <td>{item.new_location_code}</td>
                          </tr>
                        );
                      }
                    })
                  ) : (
                    <tr>
                      <td colSpan="8">No Data Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
